/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import icon_data from "../../Assets/svg/icon_data_new.svg";
import icon_sini from "../../Assets/svg/icon_sini.svg";
import icon_toolbox from "../../Assets/svg/icon_tool_new.svg";

/*CONST*/
const tabs = [
  {
    value: "data",
    icon: icon_data,
    alt: "Data",
  },
  {
    value: "sini",
    icon: icon_sini,
    alt: "Sini",
  },
  {
    value: "toolbox",
    icon: icon_toolbox,
    alt: "Toolbox",
  },
];

const SIDEBAR_MOBILE = ({ set_value_layer, set_value_properties }) => {
  const setMode = (value) => {
    set_value_layer({
      key: "statistic_mode",
      value: value,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: true,
    });
    set_value_properties({
      key: "is_mobile_close",
      value: false,
    });
    set_value_properties({
      key: "sidebar_height",
      value: 500,
    });
  };

  return (
    <div
      style={{
        paddingLeft: "25px",
        paddingRight: "25px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "39px",
        }}
      >
        {tabs.map((item, idx) => {
          return (
            <button
              key={idx}
              className="cursor_pointer"
              onClick={() => setMode(item.value)}
              style={{
                width: "36px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "18px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.4)",
              }}
            >
              <img
                src={item.icon}
                alt={item.alt}
                style={{ width: "20px", height: "20px" }}
                className="text_center"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_properties,
})(SIDEBAR_MOBILE);
